"use strict";
/*
 * Membrane React package
 * {@link https://www.npmjs.com/package/@membranehq/react}
 * v0.29.2
 */
'use client';

function getRefElement(ref) {
  if (!ref) return null;
  if (isRefObject(ref)) {
    return ref.current ?? null;
  }
  return ref;
}
function isRefObject(ref) {
  return typeof ref === "object" && ref !== null && "current" in ref;
}

export { getRefElement };
